import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront'
import { Observable, of, Subject } from 'rxjs'
import { filter, map, retry, take, tap } from 'rxjs/operators'
import { ProductReferenceType } from '../../../../models/enum/reference.enum'
import { ICustomProduct } from '../../../../models/interface/product.interface'
import { References } from '../../../../models/reference.model'
import { ReferencesService } from '../../../../services/references.service'

@Component({
    selector: 'app-custom-cart-product-references',
    templateUrl: './custom-cart-product-references.component.html',
    styleUrls: ['./custom-cart-product-references.component.scss'],
    standalone: false
})
export class CustomCartProductReferencesComponent implements OnInit {
  @Input() cartCode: string
  @Input() cartItemRemoved: Subject<boolean> = new Subject<boolean>()

  public similarProducts$: Observable<Observable<ICustomProduct>[]>
  public compatibleProducts$: Observable<Observable<ICustomProduct>[]>
  public productReferenceType = ProductReferenceType

  public loading: boolean = false
  public similarProductTitle: string = 'Similar Products'
  public compatibleProductTitle: string = 'Compatible Products'
  public carouselWidth: string = '178px'

  constructor(
    private referencesService: ReferencesService,
    private breakpointService: BreakpointService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getCartReferences()
    this.updateReferencesWhenItemRemoved()
    this.setCarrouselBreakpoints()
  }

  private getCartReferences(): void {
    this.similarProducts$ = this.getCartProductsReferences(this.productReferenceType.SIMILAR, this.cartCode)
    this.compatibleProducts$ = this.getCartProductsReferences(this.productReferenceType.COMPATIBLE, this.cartCode)
  }

  private getCartProductsReferences(referenceType: string, cartCode: string): Observable<Observable<ICustomProduct>[]> {
    return this.referencesService.getCartReferences(referenceType, cartCode).pipe(
      retry(1),
      take(1),
      filter(Boolean),
      map((references: References) => references.references.map((reference) => of(reference.target))),
      tap(() => (this.loading = false))
    )
  }

  private updateReferencesWhenItemRemoved(): void {
    this.cartItemRemoved.subscribe({
      next: () => {
        this.loading = true
        this.getCartReferences()
      }
    })
  }

  private setCarrouselBreakpoints(): void {
    this.breakpointService.breakpoint$.pipe().subscribe((pageSize) => {
      if (pageSize === BREAKPOINT.lg || pageSize === BREAKPOINT.xl) {
        this.carouselWidth = '178px'
      }
      if (pageSize === BREAKPOINT.md) {
        this.carouselWidth = '280px'
      }
      if (pageSize === BREAKPOINT.xs) {
        this.carouselWidth = '300px'
      }
      this.changeDetectorRef.detectChanges()
    })
  }
}
